/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
// Returns the original object in the order in which the keys are provided
function keysToObj(keys: string[], originObj: { [key: string]: any }) {
  return keys.reduce((acc, key) => {
    acc[key] = originObj[key];
    return acc;
  }, {});
}

// Function to help reorder a list when dropped in different position
export const reorder = (objList: { [key: string]: any }, startIndex: number, endIndex: number) => {
  let listTemp = Object.keys(objList);
  const result = listTemp.slice(0);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return keysToObj(result, objList);
};
